"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectValues = objectValues;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

const {
  hasOwnProperty
} = Object.prototype;

function* objectValues(obj) {
  if (obj == null) {
    return;
  }

  for (const key in obj) {
    if (hasOwnProperty.call(obj, key)) {
      yield obj[key];
    }
  }
}

var _default = (0, _iterable.wrapWithMethodIterable)(objectValues, {
  validateArgs(args) {
    if (!(args[0] == null || typeof args[0] === 'object')) {
      throw new Error('the argument to objectValues was not an object, null, or undefined');
    }
  }

});

exports.default = _default;